var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"injzx-tool"},[(_vm.visible)?_c('div',{ref:"injzxTool",staticClass:"injzx-box"},[_c('a-spin',{staticClass:"injzx-tool-con",attrs:{"spinning":_vm.spinning}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }